<template>
  <v-container id="campuses" fluid tag="section">
    <div id="app">
      <v-app id="inspire">
        <v-card>
          <v-tabs vertical right show-arrows align-with-title color="blue">
            <v-tab>
              <v-icon left>mdi-lock</v-icon>
              {{$i18n.t("Booking Setting")}}
            </v-tab>
            <v-tab>
              <v-icon left>mdi-lock</v-icon>
              {{ $i18n.t("Route Setting") }}
            </v-tab>
            <v-tab>
              <v-icon left>mdi-access-point</v-icon>
              {{ $i18n.t("Routing Setting") }}
            </v-tab>
            <v-tab>
              <v-icon left>mdi-access-point</v-icon>
              {{ $i18n.t("Tariff Setting") }}
            </v-tab>
            <v-tab>
              <v-icon left>mdi-access-point</v-icon>
              {{ $i18n.t("My Vehicle Type") }}
            </v-tab>
            <v-tab>
              <v-icon left>mdi-access-point</v-icon>
              {{ $i18n.t("Country Currency") }}
            </v-tab>
            <v-tab>
              <v-icon left>mdi-access-point</v-icon>
              {{ $i18n.t("Journey Gap") }}
            </v-tab>
            <v-tab>
              <v-icon left>mdi-access-point</v-icon>
              {{ $i18n.t("HelpLine") }}
            </v-tab>
            <v-tab>
              <v-icon left>mdi-access-point</v-icon>
              {{ $i18n.t("Email Setup") }}
            </v-tab>
            <v-tab>
              <v-icon left>mdi-access-point</v-icon>
              {{ $i18n.t("SMS Setup") }}
            </v-tab>
            <v-tab>
              <v-icon left>mdi-access-point</v-icon>
              {{ $i18n.t("Other Setting") }}
            </v-tab>
            <v-tab>
              <v-icon left>mdi-access-point</v-icon>
              {{ $i18n.t("Aura Setting") }}
            </v-tab>
            <!-- BookingSetting -->
            <v-tab-item>
              <v-card flat>
                <booking-setting />
              </v-card>
            </v-tab-item>
            <!-- Route Setting -->
            <v-tab-item>
              <v-card flat>
                <route-setting />
              </v-card>
            </v-tab-item>
            <!-- Routing Setting -->
            <v-tab-item>
              <v-card flat>
                <routing-setting />
              </v-card>
            </v-tab-item>
            <!-- Tariff Setting -->
            <v-tab-item>
              <v-card flat>
                <tariff-setting />
              </v-card>
            </v-tab-item>
            <!-- My Vehicle Type -->
            <v-tab-item>
              <v-card flat>
                <my-vehicle-type />
              </v-card>
            </v-tab-item>
            <!-- Country Currency Mapping -->
            <v-tab-item>
              <v-card flat>
                <country-currency-mapping />
              </v-card>
            </v-tab-item>
            <!-- Journey gap -->
            <v-tab-item>
              <v-card flat>
                <journey-gap />
              </v-card>
            </v-tab-item>
            <!-- Helpline -->
            <v-tab-item>
              <v-card flat>
                <help-line />
              </v-card>
            </v-tab-item>
            <!-- Email Setup -->
            <v-tab-item>
              <v-card flat>
                <email-setup />
              </v-card>
            </v-tab-item>
            <!-- SMS Setup -->
            <v-tab-item>
              <v-card flat>
                <sms-setup />
              </v-card>
            </v-tab-item>
            <!-- Other Setting -->
            <v-tab-item>
              <v-card flat>
                <other-setting />
              </v-card>
            </v-tab-item>
            <!-- Aura Setting -->
            <v-tab-item>
              <v-card flat>
                <aura-setting />
              </v-card>
            </v-tab-item>
          </v-tabs>
        </v-card>
      </v-app>
    </div>
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";

@Component({
  name: "SettingMenu",
  props: {
    value: {
      default: false,
    },
    corp: {
      default: false,
    },
    label: {
      default: "Settings",
    },
    clearable: {
      default: false,
    },
    rules: {
      default: () => [],
    },
  },
  components: {
    BookingSetting: () => import("@/views/settings/BookingSetting.vue"),
    RouteSetting: () => import("@/views/settings/RouteSetting.vue"),
    RoutingSetting: () => import("@/views/settings/RoutingSetting.vue"),
    AuraSetting: () => import("@/views/settings/AuraSetting.vue"),
    OtherSetting: () => import("@/views/settings/OtherSetting.vue"),
    SmsSetup: () => import("@/views/settings/SmsSetup.vue"),
    EmailSetup: () => import("@/views/settings/EmailSetup.vue"),
    HelpLine: () => import("@/views/settings/HelpLine.vue"),
    JourneyGap: () => import("@/views/settings/JourneyGap.vue"),
    MyVehicleType: () => import("@/views/settings/MyVehicleType.vue"),
    TariffSetting: () => import("@/views/settings/TariffSetting.vue"),
    CountryCurrencyMapping: () =>
      import("@/views/settings/CountryCurrencyMapping.vue"),
  },
})
export default class BuSelect extends Vue {}
</script>

<style scoped>
.v-select-list {
  padding: 0;
}
.menuable__content__active,
.v-menu__content {
  background: white;
}
.v-select__selections {
  height: 32px;
}
.height32 {
  height: 32px;
}
.text-title {
  min-width: 100px;
  float: left;
  margin: 4px 0;
  line-height: 1.2;
  font-weight: 400;
  font-size: 14px;
}
.v-tab {
  justify-content: left;
  margin-left: 0px !important;
}
</style>
